import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../shared/components/VerbButton';
import { useDispatch, useSelector } from 'react-redux';
import { getManyUserCollections, postUserCollection } from '../../../../shared/actions';
import { RuntimeContext } from '../../../../../common/RuntimeContext';

const ImproveSkillsWidget = ({}) => {
  const config = useContext(RuntimeContext);
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.loggedInUser);

  const _handleSubscribeOnClick = () => {
    const pathsLearningCollectionId = "649b38ed8805fc00114cb0fd";
    const params = {
      collectionId: pathsLearningCollectionId,
      userProfileId: user._id,
    }

    dispatch(getManyUserCollections({ ...params, pathsContext: config.pathsWeb })).then(collections => {
      if (!collections.length) {
        return dispatch(postUserCollection({ body: { collectionId: pathsLearningCollectionId}, pathsContext: config.pathsWeb })).then(() => {
          history.push('/assetlink/65e6334c45fe2606760b9dae');
        });
      }
      history.push('/assetlink/65e6334c45fe2606760b9dae');
    })
  }

  return (
      <div className={'improve-skills-widget container'}>
        <div className={'improve-skills-container'}>
          <div className={'improve-skills-card'}>
            <div className={'improve-skills-card-header'}>
              <h1 className={'improve-skills-text'}>Improve your skills with <span className={'improve-skills-text-paths'}>Paths</span></h1>
            </div>
            <div className={'improve-skills-card-body'}>
              <p>Learn and practice communicating effectively, giving feedback, delegating, handling conflict, managing time, and more.</p>
            </div>
            <div className={'improve-skills-card-buttons'}>
              <VerbButton
                onClick={_handleSubscribeOnClick}
                className={'col-5 learn-button'}
                buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}
                buttonText={'LEARN MORE'}
              />
              <VerbButton
                onClick={() => history.push('/explore')}
                className={'col-5 explore-button'}
                buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                buttonText={'EXPLORE POPULAR SKILLS'}
              />
            </div>
          </div>
        </div>
      </div>
  );
};

export default ImproveSkillsWidget;
